<template>
  <div class="viewGallery">
    <div class="topBar">
      <div class="subTitle"><i class="far fa-window-minimize" style="transform:rotate(90deg);margin-right: -5px;color:rgba(52,152,219,1);"></i>图片列表</div>
    </div>
    <div style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">
          数据列表
        </div>
        <div class="btn-right">
          <button @click="dialogVisible = true" class="btn1">添加图片</button>
        </div>

        <el-dialog title="添加图片" :visible.sync="dialogVisible" width="30%">
          <div>
            <el-row>
              <el-col :span="6">
                <div class="grid-content">选择图片：</div>
              </el-col>
              <el-col :span="18">
                <div class="grid-content">
                  <input
                    type="file"
                    id="file"
                    accept="image/png, image/jpeg, image/jpg"
                    @change="getImage($event)"
                  >
                </div>
              </el-col>
            </el-row>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="submit()">确 定</el-button>
          </span>
        </el-dialog>
      </div>

      <div class="table">
        <div class="empty" v-show="!images[0]">暂无图片</div>
        <el-row>
          <el-col :span="4" v-for="item in images" :key="item.id" class="for">
            <div class="item">
              <img v-bind:src="serve+'/'+item.image">
              
              <div class="delBtn">
                <el-checkbox v-model="checked[item.id]">删除图片</el-checkbox>
                
              </div>
              
            </div>
            <div class="delBtn1"  @click="delBtn1(item.image)">
                {{item.image}}
              </div>
          </el-col>
        </el-row>
      </div>
      <div class="pager">
        <el-row>
          <el-col :span="2" style="padding-left:10px;line-height: 34px">
            <el-checkbox v-model="selectAll" @change="selectAllFn">全选</el-checkbox>
          </el-col>
          <el-col :span="8">
            <button @click="del()" class="btn1">批量删除</button>
          </el-col>
          <el-col :span="12">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="pages"
              :page-size="30"
              @current-change="setPage"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";

export default {
  name: "gallery",
  data() {
    return { serve: this.$store.state.serve,
      dialogVisible: false,
      page: 1,
      idString: "",
      checked: [],
      pages: null,
      galleryId: this.$route.params.id,
      selectAll: false,
      images: [],
      newImage: null
    };
  },
  created() {
    this.$store.state.topActiveId = 2;
    this.$store.state.leftTitle = "图片库"; 
    this.getData();
  },
  mounted() {},
  methods: {
    delBtn1(v){
      //  window.clipboardData.setData(clipBoardContent);
    },
    getImage(e) {
      this.newImage = e.target.files[0];
    },
    submit() {
      let formData = new FormData();
      formData.append("image", this.newImage);
      formData.append("group_id", this.galleryId);
      let config = {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      };
      const loading = this.$loading({
        lock: true,
        text: "正在上传",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      var that = this;
      this.axios
        .post(this.serve+"/admin/add_photo_images", formData, config)
        .then(function(res) {
          if (res.status === 200) {
            that.getData();
            loading.close();
            that.dialogVisible = false;
          }
        })
        .catch(function(err) {
          alert("操作失败");
        });
    },
    del() {
      var that = this;
      this.$confirm("此操作将永久删除该文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          that.idString = "";
          for (var item in that.checked) {
            if (that.checked[item] == true) {
              if (that.idString == "") {
                that.idString = item;
              } else {
                that.idString = that.idString + "," + item;
              }
            }
          }
          that.axios
            .get(this.serve+"/admin/delete_photo_images", {
              params: {
                ids: that.idString
              }
            })
            .then(function(res) {
              if (res.data.status == "success") {
                that.$message({
                  type: "success",
                  message: "删除成功!"
                });
                that.getData(that.page);
              } else {
                that.$message({
                  type: "error",
                  message: "删除失败!"
                });
              }
            })
            .catch(err => {
              alert(err);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    selectAllFn(v) {
      if (this.selectAll == false) {
        for (var item in this.checked) {
          this.checked[item] = false;
        }
      } else {
        for (var item in this.checked) {
          this.checked[item] = true;
        }
      }
    },
    setPage(v) {
      this.page = v;
      this.getData();
    },
    getData() {
      var that = this;
      this.axios
        .get(this.serve+"/admin/get_photo_images", {
          params: { page: this.page, group_id: this.galleryId }
        })
        .then(function(res) {
          var json = res.data;
          that.checked = [];
          that.page = json.now_page;
          that.pages = json.page_num;
          delete json["now_page"];
          delete json["page_num"];
          for (var item in json) {
            that.checked[json[item].id] = false;
          }
          that.selectAll = false;
          that.images = json;
        });
    }
  }
};
</script>
<style lang="scss">
.viewGallery {
  background: #f5f5f5;
  color: #333;
  height: 1000px;
  .table {
    padding: 30px 0;
    background-color: #fff;
    padding-left: 20px;
  }
  .for {
    padding-right: 20px;
    margin-bottom: 20px;
  }
  .item {
    border: 1px solid #ddd;
  }
  .item img {
    width: 90%;
    height: 130px;
    padding: 5px 5%;
    margin: 0 auto;
  }
  .topBar {
    margin-bottom: 40px;
  }
  .subTitle {
    width: 1056px;
    margin: 0 auto;
    font-size: 14px;
  }
  .delBtn {
    background-color: #f5faf9;
    text-align: center;
    line-height: 40px;
  }
  .delBtn1 {
    cursor: pointer;
    background-color: #f5faf9;
    text-align: center;
    line-height: 22px;
    word-wrap: break-word;word-break: break-all;overflow: hidden;
    font-size: 12px;
    color: #999;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
  }
}
</style>